const sleep = (ms: number) => {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

export type TestFunction = () => boolean

export const sleepUntilTrue = async (testFunction: TestFunction, maxTimeout: number) => {
  const start = (new Date()).getTime()
  while (!testFunction() && start + maxTimeout > (new Date()).getTime()) {
    await sleep(100)
  }
  return testFunction()
}

export default sleep
